export default {
  required: "Required",
  maxLength: 24,
};
